<button class="sidebar-minimizer" type="button" appSidebarMinimizer appBrandMinimizer></button>
